import React from 'react';

interface SliderWithNumberInputProps {
  label: string;
  value: number;
  min?: number;
  max?: number;
  onChange: (value: number) => void;
  width?: string;
}

const SliderWithNumberInput: React.FC<SliderWithNumberInputProps> = ({
  label,
  value,
  min = 0,
  max = 100,
  onChange,
  width = '50%',
}) => {
  const clamp = (v: number) => Math.min(Math.max(min, v), max);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, width }}>
      <label style={{ color: '#444', fontSize: 14, whiteSpace: 'nowrap' }}>{label}</label>
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 8 }}>
        <input
          type="range"
          min={min}
          max={max}
          value={value}
          onChange={e => onChange(clamp(Number(e.target.value)))}
          style={{ flex: 1 }}
        />
        <div style={{ display: 'flex', alignItems: 'center', gap: 2, minWidth: 70 }}>
          <input
            type="number"
            min={min}
            max={max}
            value={value}
            onBlur={e => onChange(clamp(Number(e.target.value)))}
            onChange={e => onChange(clamp(Number(e.target.value)))}
            style={{
              width: 50,
              fontSize: 14,
              padding: '2px 4px',
              borderRadius: 4,
              border: '1px solid #bbb',
              textAlign: 'right' as const,
            }}
          />
          <span style={{ fontSize: 14, color: '#666' }}>%</span>
        </div>
      </div>
    </div>
  );
};

export default SliderWithNumberInput;
